<template>
  <div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 思政微课名称
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            placeholder="请输入思政微课名称"
            v-model="info.name"
            :maxLength="100"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div class="main-text-style">
        <span style="color: #f6350f">*</span> 思政微课类型
      </div>
      <div class="pl16">
        <a-radio-group v-model="info.courseType" @change="onChange">
          <a-radio value="1"> 公共 </a-radio>
          <a-radio value="2"> 专业 </a-radio>
          <a-radio value="3"> 实践 </a-radio>
        </a-radio-group>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 项目负责人
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            :maxLength="30"
            placeholder="请输入项目负责人"
            v-model="info.principals"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
    <!-- <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 团队类型
        </div>
        <div class="pl16">
          <a-radio-group v-model="info.teamType">
            <a-radio value="teacher">教师团队</a-radio>
            <a-radio value="student">学生团队</a-radio>
          </a-radio-group>
        </div>
      </div>
    </div> -->
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 联系电话
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            :maxLength="11"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入联系电话"
            v-model="info.phone"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
    <div class="submit-btn" @click="goStep">下 一 步</div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    editInfoStep1: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
        name: "",
        phone: "",
        principals: "",
        courseType: 0,
        teamType: "teacher",
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    let oldInfo = JSON.parse(
      sessionStorage.getItem(`step${this.$store.state.user.id}`)
    );
    if (oldInfo) {
      this.info.name = oldInfo.name;
      this.info.phone = oldInfo.phone;
      this.info.principals = oldInfo.principals;
      this.info.courseType = oldInfo.courseType;
    }
    if (this.$parent.$route.params.new === "new") {
      this.info.courseType = "1";
    }
  },
  methods: {
    onChange(e) {
      this.info.courseType = e.target.value;
      this.$forceUpdate();
    },
    goStep() {
      if (this.info && this.info.name === "") {
        if (this.info.name === "" || this.info.name == undefined) {
          this.$message.info("请填写项目名称");
          return false;
        }
      } else if (
        this.info &&
        this.info.principals === ""
      ) {
        if (this.info.principals === "" || this.info.principals == undefined) {
          this.$message.info("请填写项目负责人");
          return false;
        }
      }
      if (
        (this.info && this.info.phone && this.info.phone === "") ||
        this.info.phone == undefined
      ) {
        this.$message.error("请输入手机号");
        return false;
      } else {
        var telStr = /^[1]([3-9])[0-9]{9}$/;
        if (!telStr.test(this.info.phone)) {
          this.$message.error("请输入正确格式手机号");
          return false;
        }
      }
      this.$emit("goStep", this.info);
    },
    handleChange(id, value) { 
      this.info.courseType = id;
      this.info.courseTitle = value;
    },
  },
};
</script>

<style scoped lang="scss">
.mt30 {
  margin-top: 20px;
}
.main-text-style {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}
.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 16px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 38px;
  text-align: center;
  background: #c73630;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>
